<template>
  <div class="form">
    <div :class="wrapper.alertWrapper">
    </div>
    <form v-on:submit.prevent>
      <div class="form-group" :class="formStyle(schema.type)" v-for="(schema, index) in schema" :key="index">
        <template v-for="fields in schema.fields">
          <component
            v-bind:is="getFieldType(fields)"
            v-bind:type="fields.inputType"
            v-bind:label="fields.label"
            :key="fields.index"
            :value.sync="inputData[fields.model]"
            :grup="fields.model"
            :valueLabel="fields.value"
            :to="fields.to"
            :options="fields.options"
            :error.sync="errorData[fields.model]"
            :validation="fields.validation"
            :validationMethod="fields.method"
            :formStyle="schema.type"
            :disabled="isFieldDisabled"
            :isInitial.sync="isInitial[fields.model]"
            :event="fields.event"
            :others="fields.others"
            @goto="goto"
          >
          </component>
        </template>
      </div>
      <div :class="getButtonWrapperClass()">
        <!-- <button type="submit" value="submit"></button> -->
        <button v-for="(button, index) in buttons"
          :key="index"
          :type="button.action"
          :class="button.class"
          :value="button.action"
          :disabled="checkDisabled(button)"
          @click.stop="buttonAction(button, index)"
          class="subhead"
        >
          <div v-if="isButtonLoading[index]" class="wrapper_loading_button">
            <span >{{button.label}}</span>
            <loading-secondary class="btn-loading" :size="`button`" />
          </div>
          <span class="subhead" v-else>{{button.label}}</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Alert from '@/components/Alert'
import Checkbox from '@/components/Form/Checkbox'
import Input from '@/components/Form/Input'
import Radio from '@/components/Form/Radio'
import SelectDropdown from '@/components/Form/SelectDropdown'
import TextArea from '@/components/Form/TextArea'
import Link from '@/components/Form/Link'
import MultpleCheckbox from '@/components/Form/MultipleCheckbox'
import LoadingSecondary from '@/components/Loading/Secondary'

import { mapError, errorMessage } from '@/lib/error'
import save from '@/lib/save'
import * as validationLib from '@/lib/validation/'
const {
  checkInvalid
} = validationLib
import types from '@/lib/types'
const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

export default {
  name: 'adx-form',
  components: {
    'adx-alert': Alert,
    'adx-checkbox': Checkbox,
    'adx-input': Input,
    'adx-radio': Radio,
    'adx-selectdropdown': SelectDropdown,
    'adx-textarea': TextArea,
    'adx-link': Link,
    'adx-multiple-checkbox': MultpleCheckbox,
    'loading-secondary': LoadingSecondary
  },
  props: {
    schema: {
      required: true
    },
    onSubmit: {
      required: true
    },
    model: {
      required: false
    },
    error: {
      required: false
    },
    wrapper: {
      required: false
    },
    formType: {
      required: false,
      default: 'all'
    }
  },
  data() {
    const initalData = this.loadData()
    return {
      inputData: initalData.data,
      errorData: initalData.error,
      isInitial: initalData.init,
      buttons: this.onSubmit.buttons,
      hasInvalidData: false,
      alertError: false,
      alertMessage: undefined,
      loadingButton: [],
      isButtonLoading: [],
      buttonClicked: false,
      initialState: true
    }
  },
  mounted() {
    this.hasInvalidData = checkInvalid(this.errorData)
    this.loadingButton = this.onSubmit.buttons.map(element => {
      return element.isLoading
    })
    this.isButtonLoading = this.loadingButton
  },
  methods: {
    loadData() {
      var data = {}
      var error = {}
      var valid = {}
      var init = {}
      this.schema.forEach((value) => {
        const fields = value.fields
        fields.forEach((name) => {
          if (name.type !== `link`) {
            if (this.model) {
              data[name.model] = this.model[name.model] ? this.model[name.model] : ``
            } else {
              data[name.model] = ``
            }
            if (this.error && name.inputType !== `hidden`) {
              error[name.model] = this.error[name.model] ? this.error[name.model] : false
            }
            init[name.model] = true
          }
        })
      })
      return { data, error, valid, init }
    },
    getFieldType(fields) {
      return `adx-${fields.type}`
    },
    formStyle(style) {
      return `form-${style}`
    },
    getButtonWrapperClass() {
      const { wrapper } = this.onSubmit
      return wrapper.class
    },
    buttonAction(buttonData, index = 0) {
      if (buttonData.type === BUTTON) {
        if (buttonData.action === SUBMIT) {
          let temp = this.loadingButton.map((el, idx) => {
            if (idx === index) return true
            return false
          })
          this.loadingButton = temp
          this.buttonClicked = !this.buttonClicked
          if (this.errorData['password'] === false && this.formType === 'login') {
            this.errorData = {}
          }
          if (!checkInvalid(this.errorData)) {
            const fn = save[buttonData.action]
            const response = (async (fn, buttonData, args) => {
              const response = await fn(buttonData, args)
              let statusCode = response.status
              if (statusCode >= 200 && statusCode < 300) {
                let newArr = this.$data.loadingButton.map((el, idx) => {
                if (idx === index) return false
                  return el
                })
                this.$data.loadingButton = newArr
                this.buttonClicked = !this.buttonClicked
                this.$emit('complete', {
                  action: '',
                  args: response
                })
                return response
              } else if (statusCode >= 400) {
                if (statusCode === 400) {
                  if (response.data.error) {
                    this.makeError()
                    this.handleInternalError(response)
                  } else {
                    this.errorData = mapError(response.data, this.errorData)
                    this.$emit('error400', response)
                  }
                } else {
                  this.handleInternalError(response)
                }

                let temp1 = this.$data.loadingButton.map((el, idx) => {
                  if (idx === index) return false
                  return el
                })
                this.$data.loadingButton = temp1
                this.buttonClicked = !this.buttonClicked
              }
              // remove this block code when
              // block code above already success
              // try {
              //   const response = await fn(buttonData, args)
              //   let newArr = this.$data.loadingButton.map((el, idx) => {
              //     if (idx === index) return false
              //     return el
              //   })
              //   this.$data.loadingButton = newArr
              //   this.buttonClicked = !this.buttonClicked
              //   this.$emit('complete', {
              //     action: '',
              //     args: response
              //   })
              //   return response
              // } catch (error) {
              //   if (error) {
              //     if (error.status === 400) {
              //       this.errorData = mapError(error.data, this.errorData)

              //       this.$emit('error400', error)
              //     } else {
              //       this.handleInternalError(error)
              //     }
              //   } else {
              //     this.handleInternalError({status: 503})
              //   }
              //   let temp1 = this.$data.loadingButton.map((el, idx) => {
              //     if (idx === index) return false
              //     return el
              //   })
              //   this.$data.loadingButton = temp1
              //   this.buttonClicked = !this.buttonClicked
              // }
            })(fn, buttonData, { data: this.inputData, params: buttonData.params || undefined })
          }
        }
      }
    },
    handleInternalError(error) {
      this.alertError = true
      if (error.status === 400) {
        this.alertMessage = errorMessage[`400`](error)
        this.$notify({
          group: 'account',
          title: this.alertMessage.title,
          text: this.alertMessage.message,
          type: 'primary'
        });
      } else {
        this.alertMessage = errorMessage[error.status]
      }
      this.hasInvalidData = true
    },
    makeError() {
      Object.keys(this.errorData).map(index => { this.errorData[index] = ` ` })
    },
    checkDisabled(button) {
      if (button.type === RESET || button.action !== SUBMIT) return false
      return this.isButtonDisabled
    },
    goto(name) {
      this.$emit('goto', name)
    }
  },
  watch: {
    inputData: {
      handler() {
        this.$emit(`update:model`, this.inputData)
      },
      deep: true
    },
    isInitial: {
      handler() {
        if (this.isInitial) {
          const val = Object.keys(this.isInitial).map(key => this.isInitial[key])
          if (val.includes(true)) {
            this.initialState = true
          } else {
            this.initialState = false
          }
        }
      },
      deep: true
    },
    errorData: {
      handler() {
        this.hasInvalidData = checkInvalid(this.errorData)
        this.$emit(`update:error`, this.errorData)
      },
      deep: true
    },
    loadingButton: {
      handler: function() {
        this.isButtonLoading = this.loadingButton
      },
      deep: true
    }
  },
  computed: {
    isButtonDisabled: function() {
      if (this.formType === 'login') {
        return this.buttonClicked || this.initialState
      }
      return this.hasInvalidData || this.buttonClicked || this.initialState
    },
    isFieldDisabled: function() {
      return this.buttonClicked ? true : false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>